import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js';

export const theme = resolveConfig(tailwindConfig).theme;

export const colors = resolveConfig(tailwindConfig).theme
    ?.colors as unknown as {
    [key: string]: {
        [key: string]: string;
    };
};
